export default "__VITE_ASSET__BknT_Lg2__"